import {Injectable} from "@angular/core";
import {fromEvent, Subscription} from "rxjs";

@Injectable({
	providedIn: 'root'
})

export class SidebarHelper {
	isSidebarVisible: boolean = false;
	resizeSubscription: Subscription | undefined;

	// Util to initialize sidebar visibility based on window width
	initializeSidebar() {
		this.isSidebarVisible = window.innerWidth > 991;
		this.getAllContentStatic(this.isSidebarVisible);
	}

	// Util to destroy sidebar resize subscription
	destroySidebar() {
		if(this.resizeSubscription) {
			this.resizeSubscription.unsubscribe();
		}
	}

	// Util to setup resize subscription for responsive sidebar
	resizeSubscriptionSetup() {
		this.resizeSubscription = fromEvent(window, 'resize').subscribe(() => {
			this.isSidebarVisible = window.innerWidth > 991;
			this.getAllContentStatic(this.isSidebarVisible);
		});
	}

	// Util to manage all-content static class
	getAllContentStatic(_isSidebarVisible: boolean) {
		let allContent = document.getElementsByClassName('all-content');
		//console.log('allContent ==> ', allContent);

		if (allContent && window.innerWidth < 992) {
			if (!_isSidebarVisible) allContent[0].classList.remove('all-content-static');
			else allContent[0].classList.add('all-content-static');
		}
	}
}
